export const USER_SERVICE = "UserService";

export type User = {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  authenticationToken: string;
};
